import { render, staticRenderFns } from "./Materials.vue?vue&type=template&id=12910bce&scoped=true"
import script from "./Materials.vue?vue&type=script&lang=js"
export * from "./Materials.vue?vue&type=script&lang=js"
import style0 from "./Materials.vue?vue&type=style&index=0&id=12910bce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12910bce",
  null
  
)

export default component.exports